import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Image from "../../components/image";
import Blog from "../../components/blogFooter/blogFooter";
import { asset } from "../../helpers/dom.helper";
import { ContentWrapper } from "../../layouts";
import { Media, MediaContextProvider } from "../../media";
import BgWithText from '../../components/backgroundWithText/BgWithText';
import styles from './eia.module.scss';
import Guarantee from "../Home/guaranteeHome";
import i18n, { toRoute } from "../../i18n";

export default function Keycard() {

  const { t } = useTranslation(['translation', 'aiFacial'])

  return (
    <>
      <Helmet>
        <title>{t("aiFacial:กฎหมาย EIA คืออะไร ทำไมถึงสำคัญกับโครงการคอนโด")}</title>
        <meta name="description" content={t("aiFacial:กฎหมาย EIA สำคัญอย่างไรกับโครงการคอนโดมิเนียม มาดูสิ่งที่คุณควรรู้ก่อนตัดสินใจก่อสร้างหรือจองคอนโด และผลกระทบของการทำ EIA ในด้านสิ่งแวดล้อมและคุณภาพชีวิต")} />
        <meta name="keywords" content={t("aiFacial:metaKeyWord")} />
        <link rel="canonical" href="https://silverman.app/debtcollection" />
      </Helmet>

      <div className={styles.aiFacial}>
        <MediaContextProvider>
          <Media lessThan="md">
            <BgWithText
              data={{
                subtitle: t('settingUpJuristic:กฎหมาย EIA คืออะไร ทำไมถึงสำคัญกับโครงการคอนโด')
              }}
              image={asset('/images/settingUpJuristic/main.jpg')}
              height={350}
              noBGPosition={true}
            />
          </Media>
          <Media greaterThanOrEqual="md">
            <BgWithText
              data={{
                subtitle: t('settingUpJuristic:กฎหมาย EIA คืออะไร ทำไมถึงสำคัญกับโครงการคอนโด')
              }}
              image={asset('/images/settingUpJuristic/main.jpg')}
              height={350}
              noBGPosition={true}
            />
          </Media>
        </MediaContextProvider>
        {/* end banner */}

        {/* section1 */}
        <ContentWrapper className="py-5 main-ai-facial">
          <div style={{ maxWidth: '1100px', margin: 'auto' }}>
            <h5 className="mb-4 font-weight-400 text-center"
              dangerouslySetInnerHTML={{ __html: t('aiFacial:กฎหมาย EIA คืออะไร ทำไมถึงสำคัญกับโครงการคอนโด') }} />
            <div className="mt-4">
              <Image src={asset('/images/eia/1.png')} />
            </div>

            <p className="mb-4 font-weight-400 text-center pt-2"
              dangerouslySetInnerHTML={{ __html: t('aiFacial:ในบางครั้งความเจริญรุ่งเรืองอาจไม่ได้เป็นสิ่งที่ดีที่สุดสำหรับชุมชนเสมอไป นี่จึงเป็นเหตุผลที่ต้องมีการจัดทำ EIA (Environmental Impact Assessment) เพื่อประเมินว่า<a href="https://silverman.app/for-juristic-management?type=condominium"><u>โครงการคอนโด</u></a>ที่กำลังจะเกิดขึ้นเหมาะสมกับพื้นที่หรือไม่ สิ่งที่น่าสนใจก็คือ คอนโดมิเนียมถือเป็นหนึ่งในประเภทของโครงการที่ต้องผ่านการประเมิน EIA ก่อนเริ่มการก่อสร้าง ดังนั้น เราจึงอยากชวนทุกคนมาทำความรู้จักและเข้าใจการประเมิน EIA ให้มากขึ้น พร้อมทั้งสำรวจเหตุผลว่าทำไมการประเมินนี้จึงสำคัญต่อการตัดสินใจซื้อคอนโดมิเนียม') }} />
            <div className="row">
              <div className="col-12 col-sm-6 pl-sm-0">
                <div>
                  <p> <strong>{t('aiFacial:EIA คืออะไร?')} </strong> </p>
                  <p dangerouslySetInnerHTML={{ __html: t('aiFacial:EIA หรือ การประเมินผลกระทบสิ่งแวดล้อม (Environmental Impact Assessment) คือกระบวนการสำคัญที่ใช้ในการประเมินว่าโครงการที่กำลังจะดำเนินการนั้นจะส่งผลกระทบต่อสิ่งแวดล้อมโดยรอบอย่างไร ทั้งในแง่บวกและแง่ลบ โดยมีวัตถุประสงค์หลักเพื่อป้องกันไม่ให้พื้นที่โดยรอบได้รับผลกระทบจากการก่อสร้างอย่างไม่เหมาะสม การยื่นขอ EIA ก่อนเริ่มโครงการใหญ่ ๆ ไม่ได้จำกัดอยู่แค่ในประเทศไทยเท่านั้น หลายประเทศทั่วโลกก็มีกฎหมายหรือมาตรการคล้ายคลึงกัน แม้ชื่อเรียกอาจแตกต่างกันไป แต่แนวคิดสำคัญยังคงเหมือนกัน นั่นคือการให้ความสำคัญกับการรักษาสิ่งแวดล้อมและคุณภาพชีวิตของชุมชนรอบข้าง นอกจากผลกระทบต่อสิ่งแวดล้อม กระบวนการตรวจสอบ EIA ในประเทศไทยยังครอบคลุมถึงเรื่อง คุณภาพชีวิตของผู้คนในพื้นที่ โดยมีการกำหนดประเด็นการตรวจสอบอย่างชัดเจน 4 ด้านหลัก ดังนี้:') }} />
                  <ul className="pl-5">
                    <li><strong>ผลกระทบทางชีวภาพ</strong> จะประเมินในมุมมองที่ว่า การก่อสร้างจะก่อให้เกิดการเปลี่ยนแปลงทางกายภาพต่อสิ่งแวดล้อมอย่างไรบ้าง อาทิเช่น คุณภาพของ</li>
                    <li><strong>คีย์การ์ดแบบ Mifare Card</strong> เป็นการประเมินถึงผลกระทบที่จะเกิดขึ้นกับระบบนิเวศ ไม่ว่าจะเป็นพืชหรือสัตว์ โดยรอบโครงการ รวมไปถึงการสูญเสียความสมดุลของห่วงโซ่อาหาร</li>
                    <li><strong>คุณค่าด้านการใช้ประโยชน์</strong> ประเมินผลกระทบในด้านกายภาพและชีวภาพที่ส่งผลต่อการดำเนินชีวิตของมนุษย์ ซึ่งจะมองถึงผลประโยชน์สูงสุดที่มนุษย์จะได้รับจากการก่อสร้างโครงการ ไม่ว่าจะเป็นผู้คนรอบข้างโครงการหรือแม้กระทั่งผู้คนภายในโครงการเองก็ตาม</li>
                    <li><strong>ผลกระทบต่อคุณภาพชีวิต</strong> ในข้อนี้ค่อนข้างที่จะละเอียดอ่อนมากกว่าข้ออื่น ๆ อยู่พอสมควร เพราะมีปัจจัยอื่น ๆ ที่ต้องใช้ประเมินหลายอย่างด้วยกัน อาทิเช่น โครงการที่สร้างจะส่งผลกระทบต่อประเพณีดั้งเดิมในพื้นที่หรือไม่ ภาพรวมของเศรษฐกิจของพื้นที่โดยรอบ หรือเรื่องสุขภาพผู้คนโดยรอบ เป็นต้น                    </li>
                  </ul>
                  <p className="pt-2">ทั้งนี้ เมื่อถามว่าระบบคีย์การ์ดมีความปลอดภัยแค่ไหน? ก็ต้องยืนยันว่าเป็นระบบป้องกันความปลอดภัยด้านการเข้า-ออกของบุคคลที่ดีมาก เพราะถ้าอีกฝ่ายไม่มีคีย์การ์ดเปิดประตู ก็จะไม่สามารถเปิดหรือผ่านทางเข้า-ออกนั้น ๆ ได้เลย
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-6 pr-sm-0">
                <div className="mt-4">
                  <Image src={asset('/images/eia/2.png')} />
                </div>
              </div>
            </div><br></br><br></br>

            <div className="row">
              <div className="col-12 col-sm-6 pl-sm-0">
                <div className="mt-4">
                  <p><strong>{t('aiFacial:กฎหมาย EIA สำคัญกับโครงการคอนโดมิเนียมอย่างไรบ้าง?')}</strong></p>
                  <p dangerouslySetInnerHTML={{ __html: t('การทำ EIA มีเอาไว้เพื่อตรวจสอบผลกระทบต่อสิ่งแวดล้อมของโครงการที่กำลังก่อตั้ง ซึ่งคอนโดมิเนียมเองก็เป็นหนึ่งในประเภทโครงการที่จะต้องผ่านขั้นตอนการประเมินนี้ก่อนจะเริ่มต้นสร้างโครงการได้ ซึ่งในบางครั้งการจองคอนโดมิเนียมในช่วงเวลา Pre-Sale มักจะมีการโฆษณาด้วยคำว่า EIA APPROVED หรือก็คือผ่านการจัดทำ EIA เรียบร้อยแล้วนั่นเอง สิ่งที่ควรคำนึงก่อนการตัดสินใจซื้อคอนโดในช่วง Pre-Sale คือเราจะต้องรับรู้ว่าตัวโครงงานอยู่ในเงื่อนไขที่จะต้องผ่านการประเมิน EIA หรือไม่ ? ถ้าโครงการเป็นไปตามเงื่อนไขของการประเมินแล้วไม่สามารถประเมินผ่านได้ แน่นอนว่าโครงการจะไม่สามารถเริ่มต้นก่อสร้างได้ ปัญหาจะเกิดในกรณีที่ผู้อาศัยได้ชำระเงินสำหรับการจองหรือดาวน์คอนโดมิเนียมโครงการนั้น ๆ ไปแล้วตั้งแต่ช่วง Pre-Sale ซึ่งการขอเงินคืนจากโครงการส่วนมากจะเป็นเรื่องที่ยุ่งยาก ซับซ้อน และในบางกรณีอาจต้องขึ้นโรงขึ้นศาลเลยก็เป็นได้') }} />
                </div>
              </div>
              <div className="col-12 col-sm-6 pr-sm-0">
                <div className="mt-4">
                  <img src={asset('/images/eia/7.png')} />
                </div>
              </div>
            </div>

            <div className="pt-5">
              <p> <strong>{t('aiFacial:เกณฑ์การทำ EIA สำหรับโครงการคอนโดมิเนียมมีอะไรบ้าง')} </strong> </p>
              <div >
                <img src={asset('/images/eia/3.png')} />
              </div>
              <p className="pt-4" dangerouslySetInnerHTML={{ __html: t('aiFacial:ไม่ใช่ทุก ๆ คอนโดมิเนียมที่จะต้องทำการประเมินรายงานผลกระทบสิ่งแวดล้อม (EIA) เพราะมีกฎหมายที่ระบุเอาไว้อย่างชัดเจนในพระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ เมื่อปี พ.ศ. 2535 โดยจะจำแนกโครงการก่อสร้างอย่างชัดเจน ในส่วนของคอนโดมิเนียมจะมีเกณฑ์ดังต่อไปนี้') }} />
              <ul className="pl-5">
                <li>มีพื้นที่ใช้สอยโดยรวมแล้วมากกว่า 4,000 ตารางเมตร</li>
                <li>คอนโดมิเนียมจะต้องมีห้องชุดอย่างน้อย 80 ห้องขึ้นไป</li>
              </ul>
            </div>

            <div className="pt-4">
              <p> <strong>{t('aiFacial:ใครเป็นผู้รับผิดชอบในการจัดทำรายงาน EIA')} </strong> </p>
              <p className="pt-2" dangerouslySetInnerHTML={{ __html: t('aiFacial:ในขั้นตอนการยื่นประเมินผลกระทบต่อสิ่งแวดล้อม เจ้าของโครงการจะต้องใช้บริการของบริษัทที่ปรึกษาด้านสิ่งแวดล้อม EIA ที่ได้รับใบอนุญาตจาก <a href="https://www.onep.go.th/"><u>สำนักงานนโยบายและแผนทรัพยากรธรรมชาติและสิ่งแวดล้อม (สผ.)</u></a> ซึ่งเป็นหน่วยงานเอกชน นอกจากทำหน้าที่ประเมินแล้ว ยังสามารถให้คำปรึกษาเพื่อให้การก่อสร้างเป็นไปในแนวทางที่ไม่ขัดต่อกฎหมาย EIA โดยเฉพาะเรื่องของขอบเขตการก่อสร้าง ที่ตั้งที่เหมาะสมของโครงการ และแผนปฏิบัติระหว่างการก่อสร้าง เพื่อให้ผลการประเมินไม่มีข้อติดขัด การก่อสร้างโครงการจะได้ดำเนินได้อย่างราบรื่น') }} />
            </div>

            <div className="pt-4">
              <p> <strong>{t('aiFacial:ขั้นตอนการจัดทำและยื่น EIA สำหรับโครงการคอนโดมีอะไรบ้าง')} </strong> </p>
              <div>
                <Image src={asset('/images/eia/4.png')} />
              </div>
              <p className="pt-2" dangerouslySetInnerHTML={{ __html: t('เมื่อรู้แล้วว่าคอนโดมิเนียมที่กำลังจะก่อสร้างเป็นโครงการที่เข้าข่ายที่จะต้องประเมินผลกระทบสิ่งแวดล้อม เจ้าของโครงการควรเริ่มต้นจัดทำรายงานผลกระทบสิ่งแวดล้อม EIA โดยเร็วที่สุด โดยมีขั้นตอนดังนี้') }} />
              <ul className="pl-5">
                <li>จัดเตรียมเอกสารสำคัญต่าง ๆ และข้อมูลที่จำเป็นต้องใช้เพื่อประเมิน EIA ให้เรียบร้อย เช่น ใบอนุญาตก่อสร้าง รายการจดทะเบียน แบบรับรองการตรวจสอบอาคารชุดประจำปี เป็นต้น</li>
                <li>ยื่นรายงานให้กับสำนักงานนโยบายและแผนทรัพยากรธรรมชาติและสิ่งแวดล้อม (สผ.) ปีละ 2 ครั้ง ในช่วงเดือน กรกฎาคม และ มกราคม ใช้เวลาพิจารณาไม่เกิน 75 วันหลังจากส่งรายงาน</li>
              </ul>
            </div>

            <div className="pt-4">
              <p> <strong>{t('aiFacial:หากไม่ทำ EIA หรือทำไม่ผ่าน จะส่งผลกระทบอย่างไรบ้าง')} </strong> </p>
              <div>
                <Image src={asset('/images/eia/6.png')} />
              </div>
              <p className="pt-2" dangerouslySetInnerHTML={{ __html: t('การละเลยต่อการทำ EIA ทั้ง ๆ ที่ตัวโครงการนั้นเข้าข่ายที่จะต้องได้รับการประเมิน ถือว่าเป็นความผิดร้ายแรงอย่างมากและไม่ควรเกิดขึ้นโดยเด็ดขาด ไม่ว่าจะเป็นการก่อสร้างโดยไม่ได้ประเมิน EIA หรือประเมินแล้วแต่ยังไม่ผ่าน ต่างก็มีผลกระทบในเชิงลบที่จะตามมาในภายหลังอย่างแน่นอน ยกตัวอย่างเช่น') }} />
              <ul className="pl-5">
                <li><strong>ผลกระทบด้านกฎหมาย</strong> ถ้ามีการตรวจพบว่ามีการก่อสร้างโดยไม่ผ่านการประเมิน EIA จะมีโทษปรับสูงสุดถึง 1,000,000 บาท พร้อมกับมีการปรับรายวันจนกว่าจะมีการดำเนินการประเมิน EIA ให้ถูกต้อง ซึ่งจะต้องผ่านการประเมินตามเกณฑ์ที่กำหนดเอาไว้เท่านั้น โดยโทษปรับรายวันนั้นสูงสุดถึงวันละ 100,000 บาท และยังมีโทษจำคุกสำหรับผู้เกี่ยวข้องอีกด้วย ในกรณีที่เป็นโครงการส่งผลเสียอย่างรุนแรงต่อสิ่งแวดล้อมโดยรอบจากโทษที่กล่าวไปเมื่อสักครู่ สามารถเพิ่มให้มากขึ้นได้อีกถึงกึ่งหนึ่งเลยทีเดียว</li>
                <li><strong>ผลกระทบต่อสิ่งแวดล้อม</strong> แน่นอนว่าเมื่อไม่ได้รับการประเมิน EIA แล้วปล่อยปละละเลยจนโครงการแล้วเสร็จ ผลกระทบที่ร้ายแรงที่สุดก็จะเป็นในด้านของสิ่งแวดล้อม ในประเทศไทยมีกรณีตัวอย่างที่เป็นที่โจษจันมาจนถึงทุกวันนี้คือ <a href="https://thaipublica.org/2023/03/map-ta-phut-8-03-2566/"><u>นิคมอุตสาหกรรมมาบตาพุดในจังหวัดระยอง</u></a> ซึ่งปัจจุบันเป็นหนึ่งในจุดที่มีสารพิษมากที่สุดในประเทศไทย และอุดมไปด้วยมลภาวะที่ส่งผลเสียต่อสุขภาพมากมาย อาทิเช่น มลภาวะทางอากาศที่เกิดจากกลิ่นเหม็นจากการเผาไหม้เชื้อเพลิง มลภาวะทางน้ำที่เกิดจากการปนเปื้อนของสารเคมีที่ไม่ได้รับการบำบัดก่อนจะปล่อยคืนธรรมชาติ ปัญหาทั้งหมดล้วนเป็นบ่อเกิดของปัญหาสุขภาพของผู้คนในละแวกนั้น แม้ในส่วนของขั้นตอนของการจัดเตรียมรายงานการประเมิน EIA ที่เรากล่าวถึงในข้างต้นจะถือว่าไม่ยุ่งยาก เพียงเตรียมการข้อมูลต่าง ๆ ให้พร้อม แล้วก็ยื่นรายงานตามกำหนดการเท่านั้น ทว่าที่จริงแล้วในกระบวนการจริง ๆ ยุ่งยากกว่าที่เรากล่าวเอาไว้มาก เพราะข้อมูลที่ใช้มีหลายส่วนด้วยกัน และข้อมูลยังจะต้องตรงตามมาตรฐานที่ สำนักงานนโยบายและแผนทรัพยากรธรรมชาติและสิ่งแวดล้อม (สผ.) กำหนดเอาไว้อีกด้วย นั่นจึงเป็นเหตุผลที่ควรใช้บริการของบริษัทที่ปรึกษาด้านสิ่งแวดล้อม EIA ที่มีความเชี่ยวชาญในด้านนี้ ช่วยจัดเตรียมข้อมูลต่าง ๆ ที่จำเป็นได้อย่างครบถ้วน หลังจากผ่านการประเมินจนได้ก่อสร้างคอนโดมิเนียมเป็นที่เรียบร้อยแล้ว ก็ยังต้องดูแลจัดการให้อยู่ในมาตรฐานที่กำหนดเอาไว้ ซึ่งในส่วนนี้เป็นหน้าที่ของนิติบุคคลที่จะต้องให้ความดูแล</li>
              </ul>
            </div>

            <div className="pt-4">
              <div>
                <Image src={asset('/images/eia/5.png')} />
              </div>
              <p className="pt-4">
                <a href="https://silverman.app/juristic-support-team"><u>SILVERMAN มีทีมและเครื่องมือที่ช่วยทำให้งานบริหารงานด้านนิติบุคคลสะดวกมากขึ้นให้สะดวกมากขึ้น</u></a> ไม่ว่าจะเป็นระบบบริหารจัดการงานซ่อมบำรุง โปรแกรมบริหารคอนโด โปรแกรมบริหารจัดการทรัพย์สิน <a href="https://silverman.app/settingup-juristic"><u>บริการจัดตั้งนิติบุคคลและรับมอบโครงการจากบริษัทอสังหาริมทรัพย์</u></a> และอีกมากมาย เราพร้อมช่วยเพิ่มประสิทธิภาพในการทำงาน ลดความผิดพลาดที่อาจเกิดจากการจัดการแบบดั้งเดิม และช่วยประหยัดเวลาในการดำเนินงานได้อย่างมหาศาล ซอฟต์แวร์นี้ถูกออกแบบมาเพื่อตอบสนองความต้องการด้านการบริหารจัดการที่ซับซ้อนในยุคดิจิทัล ทำให้การจัดการงานนิติบุคคลเป็นเรื่องง่ายและสะดวกสบายยิ่งขึ้น <a href="https://silverman.app/contact"><u>ติดต่อผู้เชี่ยวชาญของเรา</u></a>ได้เลย
              </p>
            </div>
          </div>


          <h5 className="mb-2 font-weight-400 text-center pt-5"
            dangerouslySetInnerHTML={{ __html: t('aiFacial:contact-detail') }} />
          <div className="text-center keycard-regis">
            <button type="submit" className="btn btn-primary py-2 btn-register" style={{ color: '#ffffff' }}>
              <Link to={toRoute("/register")}>
                {t("aiFacial:Free Consult")}
              </Link>
            </button>
          </div>
        </ContentWrapper>

        <br></br><br></br>
        <Guarantee />
        <br></br><br></br>

        <Blog />
      </div>
    </>

  )

}
